import {Button, DialogBody, DialogFooter, DialogHeader, Input, Textarea, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import Dict from "../../helper/dict";
import {getConsultationAgentBranchFee} from "../../services/agent_branch_fee/agent_branch_fee";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {Toaster} from "../../helper/Toaster";
import jalaali from "jalaali-js";
import {TimeClock} from "../system/timeClock/timeClock";

export function ReservationBranchAndTimeForm({
                                               event,
                                               agent_id,
                                               branch_id,
                                               open,
                                               setOpen,
                                               onSave,
                                               currentAgentId,
                                               currentBranchId,
                                               currentMinute,
                                               scheduleStartTime,
                                               scheduleEndTime,
                                             }) {

  const handleOpen = () => setOpen(!open);

  const [agentId, setAgentId] = useState(currentAgentId);
  const [title, setTitle] = useState("");
  const [userStartTime, setUserStartTime] = useState(scheduleStartTime || "00:00");
  const [minute, setMinute] = useState(15);
  const [topic, setTopic] = useState("");
  const [challenge, setChallenge] = useState("");

  const [branchId, setBranchId] = useState(branch_id);

  const [branchFee, setBranchFee] = useState(0);
  const [branchVatPercentage, setBranchVatPercentage] = useState(0);
  const [consultationPrice, setConsultationPrice] = useState(0);

  const [dataLoaded, setDataLoaded] = useState(false);

  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    const new_date = event.jalaliDate.split("-")[0] + "/" + event.jalaliDate.split("-")[1] + "/" + event.jalaliDate.split("-")[2];
    setFormattedDate(new_date)
  }, [event.jalaliDate]);

  useEffect(() => {
    setBranchId(currentBranchId);
    setMinute(currentMinute)
    setAgentId(currentAgentId);
    if (!currentBranchId) {
      setDataLoaded(true);
    }
  }, []);

  useEffect(() => {
    setDataLoaded(true);
  }, [branchId])


  useEffect(() => {
    setAgentId(currentAgentId);
  }, [currentAgentId]);


  useEffect(() => {
    async function getData(branchId, agentId) {
      const result = await getConsultationAgentBranchFee(branchId, agentId);
      if (result.status === 200) {
        const {agent_branch_fee_and_vat} = result.data;
        setBranchFee(agent_branch_fee_and_vat?.price ?? 0);
        setBranchVatPercentage(agent_branch_fee_and_vat?.vat_percentage ?? 0);
      }
    }

    if (branchId && agentId) {
      getData(branchId, agentId);
    }
  }, [branchId, agentId])

  useEffect(() => {
    var price = parseInt(minute) * parseInt(branchFee)
    setConsultationPrice(price)
  }, [branchFee, minute]);

  const save = () => {
    const eventGorg = jalaali.toGregorian(parseInt(event.jalaliDate.split('-')[0]), parseInt(event.jalaliDate.split('-')[1]), parseInt(event.jalaliDate.split('-')[2]))
    if (Date.now() > Date.parse(`${eventGorg.gy}-${eventGorg.gm}-${eventGorg.gd} ${userStartTime}`)) {
      Toaster.failure(null,
        <Typography variant="small">
          امکان رزرو برای زمان‌های قبلی از اکنون ممکن نیست!
        </Typography>);
      return
    }
    onSave(agentId, branchFee, branchVatPercentage, consultationPrice, branchId, userStartTime, minute, topic, challenge);
  };

  const persianDays = {
    '1': 'شنبه',
    '2': 'یکشنبه',
    '3': 'دوشنبه',
    '4': 'سه‌شنبه',
    '5': 'چهارشنبه',
    '6': 'پنجشنبه',
    '7': 'جمعه'
  };

  if (agentId && dataLoaded) {
    return (
      <>
        <DialogHeader className="bg-gray-800 rounded-2xl border-b -mt-4">
          <div className="flex flex-col w-full textCenter">
            <Typography className="py-2 w-full text-white text-2xl z-10 textCenter">
              تعیین وقت مشاوره
            </Typography>
            <Typography className="py-2 w-full text-white text-2xl z-10 textCenter">
              {`${persianDays[event.week_day_id]} - ${persianNumberFormat(formattedDate)}`}
            </Typography>
            <Typography className="w-full pb-2 text-white text-xl z-10 textCenter">
              {persianNumberFormat(`تایم آزاد مشاور از ساعت ${scheduleStartTime.replace(/:00$/, "")} تا ساعت ${scheduleEndTime.replace(/:00$/, "")}`)}
            </Typography>
          </div>

        </DialogHeader>
        <DialogBody className="flex flex-col max-h-[550px] overflow-y-scroll">

          <div className="flex flex-row mb-4">
            <Typography color="blue-gray" variant="body2">
              لطفا توجه نمائید: اولین زمان دریافت مشاوره از 5 دقیقه بعد از رزرو امکان پذیر است.
            </Typography>
          </div>

          <div className="flex flex-row mb-4 w-full h-fit">
            <TimeClock className="" label={Dict("consultation_start_time")} value={userStartTime || "00:00"}
                       onChange={setUserStartTime}/>
          </div>

          <div className="flex flex-row mb-4 h-fit">
            <Input variant="standard"
                   label={Dict("consultation_minute")}
                   placeholder={Dict("consultation_minute")}
                   type="number"
                   min={15}
                   step={1}
                   value={minute}
                   onChange={(e) => {
                     setMinute(e.target.value)
                   }}
            />
            {consultationPrice > 0 &&
              <Typography color="blue-gray" className="flex w-full mb-4">
                {"هزینه مشاوره:" + " " + persianNumberFormat(consultationPrice, true) + " ریال"}
              </Typography>
            }
          </div>

          <div className="flex flex-row mb-4 h-fit">
            <Input variant="standard"
                   label={Dict("consultation_topic")}
                   placeholder={Dict("consultation_topic")}
                   value={topic}
                   onChange={(e) => {
                     setTopic(e.target.value)
                   }}
            />
          </div>

          <div className="flex flex-row mb-4 h-fit">
            <Textarea variant="standard"
                      label={Dict("challenge")}
                      placeholder={Dict("challenge")}
                      value={challenge}
                      onChange={(e) => {
                        setChallenge(e.target.value)
                      }}
            />
          </div>

        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ادامه</span>
          </Button>
        </DialogFooter>
      </>
    );
  }
}
